module.exports = __webpack_public_path__ + "static/IBMPlexSansCondensed-Bold-7840b939c7fbe016615ef953da17e1df.ttf";